// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90e64d85","667":"5ba68219"}[chunkId] + ".chunk.js";
};